export const INBOUND_ORDER_STATUSES = [
    'ISSUED',
    'PICKED',
    'SHIPPED',
    'PARTIALLY_RECEIVED',
];
//# sourceMappingURL=inbound-order-status.js.map